import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const TypesTable = ({ onEdit, onDelete, handlePageChange }) => {
    const { types, currentTypePage, totalTypePages } = useSelector((state) => state.admin_types);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    const filteredTypes = types.filter(type => type.title.toLowerCase().includes(searchTerm.toLowerCase()));

    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
      const toggleDropdown = (id, event) => {
        if (openDropdown === id) {
          setOpenDropdown(null);
        } else {
          const rect = event.target.getBoundingClientRect();
          setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
          setOpenDropdown(id);
        }
      };

    const handleDelete = (id) => {
        confirmAlert({
          title: 'Confirm Deletion',
          message: 'Are you sure you want to delete this type?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => onDelete(id)
            },
            {
              label: 'No',
              onClick: () => {}
            }
          ]
        });    
    };

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

    const handleScroll = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

    return (
        <>
            <div className="table-responsive">
                <table className="table table-striped table-users table-alex printarea">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Creation Date</th>
                            <th className="noprint">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTypes.length > 0 ? (
                            filteredTypes.map((type) => (
                                <tr key={type.id}>
                                    <td>
                                        <div className="text-start">{type.title}</div>
                                    </td>
                                    <td>
                                        <div>{type.creation_date}</div>
                                    </td>
                                    <td className="noprint">
                                        <div className="text-center position-relative">
                                            <button
                                                type="button"
                                                className="bg-transparent border-0 p-0 btn-vert-dots"
                                                aria-expanded={openDropdown === type.id}
                                                onClick={(e) => toggleDropdown(type.id, e)}
                                                aria-haspopup="true"
                                            >
                                                <img src={optionsIcon} alt="Options" />
                                            </button>
                                            {openDropdown === type.id && (
                                                <ul className="dropdown-menu dropdown-menu-end" 
                                                  style={{  display: 'block',
                                                        position: 'fixed',
                                                        top: `${dropdownPosition.top}px`,
                                                        left: `${dropdownPosition.left}px`,
                                                        width:`200px`,
                                                        zIndex: 1050, }}
                                                  >       
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            onClick={() => onEdit(type)}
                                                        >
                                                            <img src={editIcon} alt="Edit" /> Edit
                                                        </a>
                                                    </li>

                                                    {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                                                    <li>
                                                        <a 
                                                            className="dropdown-item" 
                                                            onClick={() => handleDelete(type.id)}
                                                        >
                                                            <img src={deleteIcon} alt="Delete" /> Delete
                                                        </a>
                                                    </li>
                                                    )}
                                                    
                                                </ul>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center">No types found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentTypePage}
                totalPages={totalTypePages}
                onPageChange={handlePageChange}
            />
        </>
    );
};

export default TypesTable;